import React from 'react'
import { Route } from 'react-router-dom'
import MainTickets from '../Views/Web/Tickets/MainTickets'
import { ClientTicketsCreate, ClientTicketsEdit, ClientTicketsMain, ClientTicketsView, IndexClientTickets } from '../Views/Web/Tickets/ClientTickets/Index'
import { IndexSupportTickets, SupportTicketsCreate, SupportTicketsEdit, SupportTicketsMain, SupportTicketsView } from '../Views/Web/Tickets/SupportTickets/Index'


function TicketsRoutes() {
    return (
      <Route path="tickets" element={<MainTickets />}>
          <Route path="client-tickets" element={<ClientTicketsMain/>} >
           <Route index element={<IndexClientTickets/>} />
           <Route path='create' element={<ClientTicketsCreate/>} />
           <Route path='edit/:clientTickEditId' element={<ClientTicketsEdit/>} />
           <Route path='view/:clientTickViewId' element={<ClientTicketsView/>} />
          </Route>

          <Route path="support-tickets" element={<SupportTicketsMain/>} >
           <Route index element={<IndexSupportTickets/>} />
           <Route path='create' element={<SupportTicketsCreate/>} />
           <Route path='edit/:supportTickEditId' element={<SupportTicketsEdit/>} />
           <Route path='view/:supportTickViewId' element={<SupportTicketsView/>} />
          </Route>
          
      </Route>
    )
  }
  
  export default TicketsRoutes